import * as React from 'react';

var getTextColor = function getTextColor(_ref) {
  var checked = _ref.checked,
    indeterminate = _ref.indeterminate,
    disabled = _ref.disabled;
  if (disabled) {
    return 'base.disabled';
  }
  if (indeterminate || checked) {
    return 'product.primary';
  }
  return 'deprecated.secondary.interactive';
};
var useInputState = function useInputState(_ref2) {
  var state = _ref2.state,
    selection = _ref2.selection,
    onInputChange = _ref2.onInputChange,
    onChange = _ref2.onChange;
  var inputRef = React.useRef(null);
  var disabled = state === 'disabled';
  var checked = selection === 'selected';
  var indeterminate = selection === 'indeterminate';
  React.useEffect(function () {
    if (indeterminate && inputRef !== null && inputRef !== void 0 && inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [inputRef, indeterminate]);
  var onInputChangeHandler = function onInputChangeHandler(e) {
    onInputChange === null || onInputChange === void 0 || onInputChange(checked);
    onChange === null || onChange === void 0 || onChange(e);
  };
  var textColor = getTextColor({
    checked: checked,
    indeterminate: indeterminate,
    disabled: disabled
  });
  return {
    textColor: textColor,
    onInputChangeHandler: onInputChangeHandler,
    inputRef: inputRef,
    disabled: disabled,
    checked: checked
  };
};

export { useInputState };
//# sourceMappingURL=useInputState.js.map
